import type { CSSInterpolation } from '@emotion/serialize';
import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';

import { Title as _Title } from '../Title';

const LogoContainer = styled.div({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
  overflow: 'hidden',
});

const LogoLink = styled.a(
  ({ theme, onClick }): CSSInterpolation => ({
    width: '100%',
    height: '100%',
    display: 'flex',
    textDecoration: 'none',
    gap: theme.eclipseTier1.spacing['12px'],
    borderRadius: theme.eclipseTier1.radius['8px'],
    outlineOffset: -2,

    ':focus-visible': { outline: `2px solid ${theme.eclipseTier2Color.border.focus}` },

    ...(onClick && {
      cursor: 'pointer',
      ':active': {
        [sel.Title]: {
          color: theme.eclipseTier2Color.text.brand.pressed,
        },
      },
    }),
  }),
);

const Logo = styled.img({
  maxHeight: '100%',
  maxWidth: '100%',
  display: 'block',
  alignSelf: 'center',
});

const Title = styled(_Title)(({ theme }) => ({
  color: theme.eclipseTier2Color.text.brand.default,
}));

const components = { LogoContainer, LogoLink, Logo, Title };
const { cls, sel } = createClassNames('Logo', components);

export const S = {
  ...components,
  cls,
  sel,
} as const;
